var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BaseApi from '~/api/base';
import { keysToCamel } from '../../utils/toCamelCase';
import mockMetadata from './mock.json';
class OrgMetadata extends BaseApi {
    constructor() {
        super('/metadata');
    }
    get() {
        if (this.useMock) {
            return keysToCamel(mockMetadata);
        }
        return super.get();
    }
    update(primaryId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.useMock) {
                return Object.assign(Object.assign({}, payload), { id: primaryId });
            }
            if (payload.id) {
                delete payload.id;
            }
            payload.organization_id = BaseApi.organizationId;
            const response = yield fetch(`${this.url}/${primaryId}`, {
                method: 'PATCH',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(payload),
            });
            if (response && response.status === 200) {
                const res = yield response.json();
                if ((res === null || res === void 0 ? void 0 : res.status_code) !== 200) {
                    throw new Error(res === null || res === void 0 ? void 0 : res.message);
                }
                return keysToCamel(res.data);
            }
        });
    }
}
const OrgMetadataApi = new OrgMetadata();
export default OrgMetadataApi;
